import z from 'zod';
import { entity, customerRef, zoneRef, string, } from '../common';
export const customerAlarmCenterRelation = z.object({
    ...entity.shape,
    migrationKey: string.optional(),
    alarmCenter: customerRef,
    customer: customerRef,
    enabled: z.boolean(),
    zones: zoneRef.array().nullable(),
    priority: z.number().optional(),
});
